import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const createCampaignApi = async (payload = {}, authHeaders = {}) => {
  try {
    const res = await apiCallPost(apiPaths.campaign, payload, authHeaders);
    return res;
  } catch (err) {
    return { status: false, errMsg: err.message || 'Failed to create campaign' };
  }
};